<ng-container *ngIf="isDrawEnabled || isResolvedEnabled">
  <div class="actions">
    <button *ngIf="isDrawEnabled"
            mat-flat-button
            color="primary"
            (click)="onClickDrawFunds()">
      DRAW FUNDS
    </button>
    <button *ngIf="isResolvedEnabled"
            mat-stroked-button
            color="primary"
            (click)="onClickResolved()">
      PAYOFF
    </button>
  </div>
</ng-container>
